export const config = {
  title: 'Modsen hallmarks',
  config: [
    {
      id: 1,
      title: `Full-stack\nsenior-level\nengineers`,
      text: 'The quality of the products we\nbuild fully relies on a team of\ndedicated, highly expertised,\nand proactive custom\nsoftware development experts.\nHere at Modsen, we’ve set the\nbar high to ensure that your\nproject will be in competent\nhands.',
      imagePath: '/images/team-talk-hexagon.svg',
      imageWidth: '88',
      imageHeight: '87',
      alt: 'Full-stack senior-level engineers',
      imageTitle: 'Full-stack senior-level engineers',
    },
    {
      id: 2,
      title: 'Unlimited software\ndevelopment\nopportunities',
      text: 'We have launched dozens of\nsuccessful software products for\nbusinesses from 25+ industries.\nSuch extensive experience allows\nus to get the excellent hang of\nyour internal processes and\ndomain specificities to develop\ntailor-made custom solutions that\nwill become an integral part of\nyour business.',
      imagePath: '/images/chart-up-hexagon.svg',
      imageWidth: '91',
      imageHeight: '87',
      alt: 'Software development opportunities',
      imageTitle: 'Software development opportunities',
    },
    {
      id: 3,
      title: 'Devotion\nto Agile\nmethodologies',
      text: 'We believe that an iterative\napproach to project\nmanagement is essential for\neffective and progressive\nsoftware building. It makes the\ndevelopment process 100%\ntransparent and productive,\nallowing you to monitor each\nstep of your software product\ncreation.',
      imagePath: '/images/gear-check-hexagon.svg',
      imageWidth: '95',
      imageHeight: '87',
      alt: 'Agile methodologies',
      imageTitle: 'Agile methodologies',
    },
  ],
}
